import { render, staticRenderFns } from "./AboutUsPage.vue?vue&type=template&id=8e891c0a&scoped=true&"
import script from "./AboutUsPage.vue?vue&type=script&lang=js&"
export * from "./AboutUsPage.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsPage.vue?vue&type=style&index=0&id=8e891c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e891c0a",
  null
  
)

export default component.exports